import type { Money } from "@upserve/financials";
import type { CheckInfo } from "types/mobile_pay";

export function getCheckTotal(checkInfo: CheckInfo): Money {
  const { netTotal, mandatoryTipAmount, tax } = checkInfo;
  return netTotal.add(mandatoryTipAmount).add(tax);
}
